module.exports = __webpack_public_path__ + "media/28_BL.0c8a2553.mp3";